<template>
  <div class="about">
    <h1>Oops, page not found.</h1>
  </div>
</template>
